// extracted by mini-css-extract-plugin
export default {"menuWrapper":"cabinet_menuWrapper__+gMBX","pageContent":"cabinet_pageContent__Rq6aU","cabinetContainer":"cabinet_cabinetContainer__edrWk"};